import React from 'react';

const Hero = () => {
  return (
    <section 
      className="relative min-h-[50.63rem] flex items-center overflow-hidden bg-primary hero-bg-responsive"
      style={{
        backgroundImage: `url('https://acs.gedhemedia.com/aksherob.webp')`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}
      aria-label="Hero Section"
    >
      {/* Brand Overlay - Desktop: Darker on the left to support white text */}
      <div 
        className="absolute inset-0 z-10 pointer-events-none hidden lg:block"
        style={{
          background: 'linear-gradient(to right, rgba(20,30,48,0.95) 0%, rgba(20,30,48,0.7) 35%, rgba(20,30,48,0) 100%)',
        }}
      ></div>
      
      {/* Brand Overlay - Mobile: Bottom-up gradient to protect text area */}
      <div 
        className="absolute inset-0 z-10 lg:hidden bg-gradient-to-t from-[#141E30]/95 via-[#141E30]/60 to-transparent pointer-events-none"
      ></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-24 relative z-20 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-12">
          <div className="animate-in fade-in slide-in-from-left duration-1000">
            <div className="max-w-2xl">
              {/* Higher contrast badge - Darkened background for better white text visibility */}
              <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full bg-[#1e293b]/80 border border-white/20 text-white font-bold text-[10px] sm:text-xs uppercase tracking-widest mb-8 backdrop-blur-md shadow-lg">
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
                </span>
                <span>Partner Akademik Terpercaya</span>
              </div>
              
              {/* High contrast heading with layered shadows */}
              <h1 className="text-4xl sm:text-5xl lg:text-7xl font-extrabold mb-6 text-white leading-[1.1] tracking-tight drop-shadow-strong">
                Selesaikan Pekerjaan <br />
                <span className="text-white">Akademik Tanpa Stres</span>
              </h1>
              
              {/* Enhanced paragraph readability */}
              <p className="text-lg sm:text-xl lg:text-2xl mb-12 text-gray-100 font-medium leading-relaxed max-w-lg drop-shadow-md">
                Fokus pada riset dan pencapaian tertinggi Anda, biarkan urusan teknis kami yang tangani secara profesional.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-6">
                <button className="bg-white text-primary px-10 py-4 rounded-xl font-bold text-lg hover:shadow-2xl hover:-translate-y-0.5 transition-all shadow-xl">
                  Konsultasi Gratis
                </button>
                <button className="bg-primary/40 border-2 border-white text-white px-10 py-4 rounded-xl font-bold text-lg hover:bg-white/10 transition-all backdrop-blur-md shadow-lg">
                  Lihat Layanan
                </button>
              </div>

              {/* High contrast stats */}
              <div className="mt-16 flex items-center space-x-12 border-t border-white/20 pt-10">
                <div className="drop-shadow-lg">
                  <p className="text-white font-black text-4xl mb-1">500+</p>
                  <p className="text-gray-300 text-[10px] font-extrabold uppercase tracking-widest">Klien Puas</p>
                </div>
                <div className="w-px h-10 bg-white/30"></div>
                <div className="drop-shadow-lg">
                  <p className="text-white font-black text-4xl mb-1">99%</p>
                  <p className="text-gray-300 text-[10px] font-extrabold uppercase tracking-widest">Tepat Waktu</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="hidden lg:block h-full"></div>
        </div>
      </div>

      <style>
        {`
          .hero-bg-responsive {
            background-position: right center;
          }
          /* Layered shadow for maximum contrast on any background */
          .drop-shadow-strong {
            filter: drop-shadow(0 2px 2px rgba(0,0,0,0.8)) drop-shadow(0 4px 10px rgba(0,0,0,0.4));
          }
          @media (max-width: 1023px) {
            .hero-bg-responsive {
              background-position: 65% center !important;
            }
          }
        `}
      </style>
    </section>
  );
};

export default Hero;